// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isProduction } from '../../../../utils';

const FallbackErrorComponent = ({ errorMessage, componentName, moduleDetails }) => {
  const isProd = isProduction();
  if (isProd) {
    return null;
  }
  const { isHomePage, moduleName, moduleId, slotIndex } = moduleDetails || {};
  return (
    <>
      {isHomePage ? (
        <aside role="alert">
          <span>{'Something went wrong in -- '}</span>
          <span>
            <strong>{moduleName}</strong>
          </span>
          <span>{'Component and module ID -  '}</span>
          <span>
            <strong>{moduleId}</strong>
          </span>
          <span>{` - on slot - `}</span>
          <span>
            <strong>{slotIndex}</strong>
          </span>
          <p>{errorMessage}</p>
        </aside>
      ) : (
        <aside role="alert">
          Something went wrong in--
          <span>
            <strong>{componentName}</strong>
          </span>
          Component.
          <p>{errorMessage}</p>
        </aside>
      )}
    </>
  );
};

FallbackErrorComponent.propTypes = {
  errorMessage: PropTypes.string,
  componentName: PropTypes.string,
  moduleDetails: PropTypes.shape({
    moduleId: PropTypes.string,
    isHomePage: PropTypes.bool,
    moduleName: PropTypes.string,
  }),
};

FallbackErrorComponent.defaultProps = {
  errorMessage: '',
  componentName: '',
  moduleDetails: {
    isHomePage: false,
    moduleId: '',
    moduleName: '',
  },
};

export default FallbackErrorComponent;
